/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";

export function useDebouncedEffect(
  effect: () => void,
  deps: React.DependencyList,
  delay: number
) {
  const handler = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (handler.current) {
      clearTimeout(handler.current);
    }

    handler.current = setTimeout(() => {
      effect();
    }, delay);

    return () => {
      if (handler.current) {
        clearTimeout(handler.current);
      }
    };
  }, deps);
}
